import { Smartphone, Monitor, Maximize2 } from "lucide-react";
import { useDevice } from "../context/DeviceContext";

const options = [
  { value: "mobile", label: "Mobile", Icon: Smartphone },
  { value: "desktop", label: "Desktop", Icon: Monitor },
  { value: "auto", label: "Auto", Icon: Maximize2 },
];

export const DevicePreviewToggle = () => {
  const { previewMode, setPreviewMode } = useDevice();

  if (process.env.NODE_ENV === "production") {
    return null;
  }

  return (
    <div
      data-testid="device-preview-toggle"
      className="fixed top-4 right-4 z-[9999] bg-honda-sidebar text-white rounded-full shadow-lg p-1 flex items-center gap-1 backdrop-blur"
    >
      {options.map(({ value, label, Icon }) => {
        const active = previewMode === value;
        return (
          <button
            key={value}
            data-testid={`preview-mode-${value}`}
            onClick={() => setPreviewMode(value)}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${
              active
                ? "bg-honda-red text-white"
                : "text-gray-300 hover:text-white hover:bg-honda-sidebar-hover"
            }`}
            title={`Preview as ${label}`}
          >
            <Icon size={14} />
            <span className="hidden sm:inline">{label}</span>
          </button>
        );
      })}
    </div>
  );
};
